import { css } from "@emotion/react"
import { theme } from "@/theme"
import { useMobileLayoutProps } from "@/hooks/useMobileLayoutProps"
import { useTranslation } from "@/hooks/useTranslation"

export const WaitingUploadPage = () => {
    const { t } = useTranslation()
    const { rootProps, bodyProps } = useMobileLayoutProps()

    return (
        <main {...rootProps}>
            <div
                {...bodyProps}
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                `}
            >
                <div
                    css={css`
                        margin: 2em;
                        font-size: 20px;
                        font-weight: bold;
                        color: ${theme.palette.intentions.text.primary};
                    `}
                >
                    {t("すべての写真の送信完了までお待ち下さい…")}
                </div>
            </div>
        </main>
    )
}
